import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./PrinterRegister.css"
import { probePrinter } from "../../renderer/platform";

export default function PrinterRegister() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [printerUrl, setPrinterUrl] = useState("");

  useEffect(() => {
    const registerPrinter = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const ip = params.get("ip");
        const port = params.get("port");

        const portNumber = Number(port);
        if (!ip || !Number.isInteger(portNumber) || portNumber < 1 || portNumber > 65535) {
          setStatus("error");
          toast.error("Missing IP or port parameters");
          setTimeout(() => navigate("/", { replace: true }), 2000);
          return;
        }

        const result = await probePrinter({ host: ip, port: portNumber });
        if (!result.reachable || !result.baseUrl) {
          throw new Error(result.message || "Printer helper did not respond");
        }
        const url = result.baseUrl;
        setPrinterUrl(url);

        // Store in localStorage
        localStorage.setItem("PRINTER_URL", url);
        setStatus("success");
        toast.success(`Printer registered Succesfully`);
        
        // Give user time to see success message
        setTimeout(() => navigate("/", { replace: true }), 1500);
        
      } catch (error) {
        console.error("Printer registration failed", error);
        setStatus("error");
        toast.error("Failed to register printer");
        setTimeout(() => navigate("/", { replace: true }), 2000);
      }
    };

    registerPrinter();
  }, [navigate]);

  return (
    <div className="printer-register-page">
      <div className="printer-register-card">
        {status === "loading" && (
          <>
            <div className="printer-title">
              Connecting to printer…
            </div>
            <div className="printer-text">
              Setting up printer connection.<br />
              Please wait.
            </div>
          </>
        )}

        {status === "success" && (
          <>
            <div className="printer-title success">
             Printer connected
            </div>

            <div className="printer-text">
              Printer is ready to use
            </div>

            <div className="printer-url">
              {printerUrl}
            </div>

            <div className="printer-footer">
              Returning to app…
            </div>
          </>
        )}

        {status === "error" && (
          <>
            <div className="printer-title error">
              ❌ Printer connection failed
            </div>

            <div className="printer-text">
              Unable to register the printer.<br />
              Please ensure the helper app is running and try again.
            </div>

            <div className="printer-footer">
              Returning to app…
            </div>
          </>
        )}
      </div>
    </div>
  );
}
